$(function () {
  $(document).on('change', 'select.ninex-country_id-field', async function () {
    const _this = $(this);

    // Handle reset address form
    _this
      .closest('form')
      .find(
        'select.ninex-province_id-field option, select.ninex-district_id-field option, select.ninex-ward_id-field option, select.ninex-street_id-field option'
      )
      .not(':first')
      .remove();

    // Check country ID
    const country_id = _this.children('option:selected').val();
    if (parseInt(country_id) == 0) return;

    // Get data from local storage
    const provinceKey = 'PROVINCES_' + country_id + LOCAL_DATA_VERSION;
    const provinces = getLocalData(provinceKey);
    if (provinces) {
      _this.closest('form').find('select.ninex-province_id-field').html(districts.toString());
    } else {
      // Get data from API
      $.ajax({
        type: 'GET',
        url: '/api/addresses-html/provinces/' + country_id,
        dataType: 'html',
        retryLimit: 2,
        timeout: 3000,
      }).done(function (data) {
        if (data) {
          // Set local data in 1 week
          setLocalData(provinceKey, data, parseInt(new Date().getTime() / 1000) + 604800);
          _this.closest('form').find('select.ninex-province_id-field').html(data.toString());
        }
      });
    }
  });

  $(document).on('change', 'select.ninex-province_id-field', function () {
    const _this = $(this);

    // Handle reset address form
    _this
      .closest('form')
      .find(
        'select.ninex-district_id-field option, select.ninex-ward_id-field option, select.ninex-street_id-field option'
      )
      .not(':first')
      .remove();

    // Check province ID
    const province_id = _this.children('option:selected').val();
    if (parseInt(province_id) == 0) return;

    // Get data from local storage
    const districtKey = 'DISTRICTS_' + province_id + LOCAL_DATA_VERSION;
    const districts = getLocalData(districtKey);
    if (districts) {
      _this.closest('form').find('select.ninex-district_id-field').html(districts.toString());
    } else {
      // Get data from API
      $.ajax({
        type: 'GET',
        url: '/api/addresses-html/districts/' + province_id,
        dataType: 'html',
        retryLimit: 2,
        timeout: 3000,
      }).done(function (data) {
        if (data) {
          // Set local data in 1 week
          setLocalData(districtKey, data, parseInt(new Date().getTime() / 1000) + 604800);
          _this.closest('form').find('select.ninex-district_id-field').html(data.toString());
        }
      });
    }
  });

  $(document).on('change', 'select.ninex-district_id-field', async function () {
    const _this = $(this);

    // Handle reset address form
    _this.closest('form').find('select.ninex-ward_id-field option').not(':first').remove();
    _this.closest('form').find('select.ninex-street_id-field option').not(':first').remove();

    // Check district ID
    const district_id = $(this).children('option:selected').val();
    if (parseInt(district_id) == 0) return;

    // =================================================================
    // Get data for WARDS
    // Get data from local storage
    const wardKey = 'WARDS_' + district_id + LOCAL_DATA_VERSION;
    const wards = getLocalData(wardKey);
    if (wards) {
      _this.closest('form').find('select.ninex-ward_id-field').html(wards.toString());
    } else {
      // Get data from API
      $.ajax({
        type: 'GET',
        url: '/api/addresses-html/wards/' + district_id,
        dataType: 'html',
        retryLimit: 2,
        timeout: 3000,
      }).done(function (data) {
        if (data) {
          // Set local data in 1 week
          setLocalData(wardKey, data, parseInt(new Date().getTime() / 1000) + 604800);
          _this.closest('form').find('select.ninex-ward_id-field').html(data.toString());
        }
      });
    }
    // =================================================================

    // =================================================================
    // Get data for STREETS
    // Get data from local storage
    const streetKey = 'STREETS_' + district_id + LOCAL_DATA_VERSION;
    const streets = getLocalData(streetKey);
    if (streets) {
      _this.closest('form').find('select.ninex-street_id-field').html(streets.toString());
    } else {
      // Get data from API
      $.ajax({
        type: 'GET',
        url: '/api/addresses-html/streets/' + district_id,
        dataType: 'html',
        retryLimit: 2,
        timeout: 3000,
      }).done(function (data) {
        if (data) {
          // Set local data in 1 week
          setLocalData(streetKey, data, parseInt(new Date().getTime() / 1000) + 604800);
          _this.closest('form').find('select.ninex-street_id-field').html(data.toString());
        }
      });
    }
    // =================================================================
  });
});
